import React from 'react';
import Resource from './../../../common/Resource'
import Panel from '../../../common/layout/Panel'


export default class extends React.Component {

    render () {
        const group_id = this.props.match.params.group_id;
        const data = {
            url: `/admin/carriers/settings/rewrite/${group_id}/items`,
            data: {
                data: [],
                metadata: []
            },
            metadata: [
                    {
                        'label': 'id',
                        'source': 'ATROUTREWRITEID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Number Pattern',
                        'source': 'ATRPATTERN',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'Number pattern (empty to match all)'
                    },
                    {
                        'label': 'Block This Range',
                        'source': 'ATRBLOCK',
                        'type': 'checkbox',
                        'editable': true,
                        'visible': true,
                        'default' : false
                    },
                    {
                        'label': 'Rewrite to',
                        'source': 'ATRREWRITE',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'Rewritten pattern'
                    },
                    {
                        'label': 'Enable Rule',
                        'source': 'ATRSTATUS',
                        'type': 'checkbox',
                        'editable': true,
                        'visible': true,
                        'default' : true
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]

            }
            return (
            <Panel title = "Carrier Outgoing Rewrite Rules">
                <Resource data = {data} {...this.props} addButtonValue="Add Outgoing Rewrite Rule" />
            </Panel>
        )
    }
}
